import { CombinedFacets, GridType } from "../model/grid.model";

export const checkGridTypeFacet = (
    combinedFacets: CombinedFacets[],
    filteredFacetName: string,
): boolean =>
    combinedFacets.some((facet) => facet.facetName !== filteredFacetName);

export const computeGridType = (
    gridType: GridType,
    isFacetEnabled: boolean,
    isGridTypeFacet: boolean,
): GridType => {
    if (gridType === GridType.search) {
        return gridType;
    }

    if (isFacetEnabled || isGridTypeFacet || gridType === GridType.facet) {
        return GridType.facet;
    }

    return GridType.category;
};
